import axios from 'axios';

// Create the API client without the Authorization header in the initial config
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'x-client-domain': window.location.hostname
  },
  timeout: 30000 // 30 seconds
});

// Add a request interceptor to dynamically include the token on each request
apiClient.interceptors.request.use(
  config => {
    // Get the latest token from localStorage on each request
    const authTokens = JSON.parse(localStorage.getItem('auth_tokens'));

    if (authTokens?.access_token) {
      config.headers.Authorization = `Bearer ${authTokens.access_token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// You can also add a response interceptor to handle token refresh if needed
apiClient.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const originalRequest = error.config;

    // If the error is 401 Unauthorized and we haven't tried to refresh yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // You would implement token refresh logic here
        // const refreshToken = JSON.parse(localStorage.getItem('auth_tokens'))?.refresh_token;
        // const response = await refreshTokenAPI(refreshToken);
        // localStorage.setItem('auth_tokens', JSON.stringify(response.data));

        // Then retry the original request with the new token
        // const authTokens = JSON.parse(localStorage.getItem('auth_tokens'));
        // originalRequest.headers.Authorization = `Bearer ${authTokens.access_token}`;
        // return axios(originalRequest);

        // For now, we'll just reject since refresh logic is app-specific
        return Promise.reject(error);
      } catch (refreshError) {
        // Handle refresh token failure (e.g., redirect to login)
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
